import { createFileRoute } from '@tanstack/react-router';
import { MapshotViewer, MapSearchParams } from '../components/MapshotViewer';
import { MapshotManifest } from '../types/mapshot';
import '../index.css';

const TILES_BASE_PATH = '/tiles/';

export const Route = createFileRoute('/')({
  validateSearch: (search: Record<string, unknown>): MapSearchParams => ({
    x: search.x !== undefined ? Number(search.x) : undefined,
    y: search.y !== undefined ? Number(search.y) : undefined,
    z: search.z !== undefined ? Number(search.z) : undefined,
    s: search.s !== undefined ? String(search.s) : undefined,
  }),
  loader: async (): Promise<MapshotManifest> => {
    const res = await fetch(`${TILES_BASE_PATH}mapshot.json`);
    if (!res.ok) throw new Error(`Failed to load manifest: HTTP ${res.status}`);
    return res.json();
  },
  component: Index,
});

function Index() {
  const manifest = Route.useLoaderData();

  return (
    <div className="w-full h-screen">
      <MapshotViewer manifest={manifest} basePath={TILES_BASE_PATH} />
    </div>
  );
}
